module.exports = __webpack_public_path__ + "static/media/calendar_icon.9a248341.svg";